export enum LinkType {
  Arrow = 'arrow',
  Document = 'document',
  SignIn = 'signIn',
  SignOut = 'signOut',
  Contact = 'contact',
  MyPages = 'myPages',
  MiniCart = 'miniCart',
}
